// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio {
    padding-bottom: 1.25em;
}

    .radio > * {
        margin-right: 7px;
    }

.objProp {
    border: 1px solid lightgray;
    border-radius: 4px;
    margin: 2px 0px;
    padding: 2px;
}

.objectListCB {
    margin: 0px 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/objectoperations/objecttorel/objecttorel.settings.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".radio {\n    padding-bottom: 1.25em;\n}\n\n    .radio > * {\n        margin-right: 7px;\n    }\n\n.objProp {\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    margin: 2px 0px;\n    padding: 2px;\n}\n\n.objectListCB {\n    margin: 0px 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
